import { Alert } from "@website/ui/alert";
import { useSnackbarItem } from "@website/ui/snackbar/components/snackbar-item/snackbar-item.hook";
import styles from "@website/ui/snackbar/components/snackbar-item/snackbar-item.module.scss";
import { SnackbarItemPropertiesType } from "@website/ui/snackbar/components/snackbar-item/snackbar-item.types";
import { FC, memo } from "react";

const SnackbarItem: FC<SnackbarItemPropertiesType> = (properties) => {
  const { index } = properties;
  const { alertProps, show } = useSnackbarItem(properties);

  return (
    <Alert
      {...alertProps}
      className={`${styles["container"]} ${show ? "" : styles["hide"]} ${
        index === 0 && styles["first"]
      } ${index === 1 && styles["second"]} ${index === 2 && styles["third"]}`}
    />
  );
};

const SnackbarItemMemoized = memo(SnackbarItem);
export { SnackbarItemMemoized as SnackbarItem };
